import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { TSDViewGeneralInfoFormValues } from './validateTSDViewGeneralInfoForm';

interface TSDWarehouseSectionProps {
  form: UseFormReturnType<TSDViewGeneralInfoFormValues>;
  disabled: boolean;
}

export const TSDWarehouseSection: React.FC<TSDWarehouseSectionProps> = ({ form, disabled }) => {
  const codelistSystems = useCodeListSystem({});

  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Warehouse
      </Title>

      <Grid>
        <Grid.Col span={4}>
          <MultiLangCodes {...form.getInputProps('warehouse.type')} label="Warehouse type" code="CL099" system={codelistSystems} disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={4}>
          <TextInput {...form.getInputProps('warehouse.identifier')} label="Warehouse identifier" disabled={disabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
